import cn from 'classnames';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { DEFAULT_MEDICAL_IMAGE_HEIGHT } from '@/shared/config';

import styles from './DragAndDropHint.module.scss';

type DragAndDropHintProps = {
  className?: string;
  testID?: string;
};

export const DragAndDropHint: FC<DragAndDropHintProps> = (props) => {
  const { className, testID } = props;

  return (
    <div
      className={cn(styles.container, className)}
      data-testid={testID}
      data-component="tooth-drag-drop-hint"
      style={{
        width: DEFAULT_MEDICAL_IMAGE_HEIGHT,
        height: DEFAULT_MEDICAL_IMAGE_HEIGHT,
      }}
    >
      <h6 className={cn(styles.medicalImagesTitle, 'h6')}>
        <FormattedMessage
          id="selectedMedicalImages.addImage"
          defaultMessage="Add image"
        />
      </h6>

      <span className={cn(styles.medicalImagesDescription, 'p3')}>
        <FormattedMessage
          id="selectedMedicalImages.dragDropDescription"
          defaultMessage="drag&drop images here"
        />
      </span>
    </div>
  );
};
